'use strict';

/**
 *
 * @name: postGroup
 *
 */

import DirectiveTemplate from './nn-post-group.directive.html';
import './nn-post-group.directive.scss';

function PostGroupDirective(transObject) {

  'ngInject';

  return {
    replace: true,
    restrict: 'A',
    scope: {
      content: '&',
      loaded: '='
    },
    template: DirectiveTemplate,
    link: function (scope, $rootScope) {

      /*
       *
       * @CONFIG
       *
       */

      scope.item = scope.content();
      scope.title = scope.item.title || 'Module title';
      scope.subtitle = scope.item.jsonData.subtitle || false;
      scope.stories = translateStory(scope.item);
      scope.storyWidth = (100 - scope.stories.length * 2) / scope.stories.length;

      setTimeout(function () {

        scope.loaded = true;
      }, 1000);

      /*
      *
      * @PUBLIC
      *
      */

      scope.onAnalyticsClick = story => {
        console.log(story)
        console.log(scope,1231999);//bysxz 埋点
        window._hmt.push(['_trackEvent', '组件', 'click', `parentType=${scope.item.parentType},index=${scope.item.index},moduleId=${scope.item.id},parentSlug=${scope.item.parentSlug || ''}`]);
        $rootScope.analytics.videoAM('editorial', scope.item.jsonData.sources[0].title, story)
      }

      /*
       *
       * @PRIVATE
       *
       */

      function _getOrderArray(data) {

        return Object.keys(data)
          .map(function (key) {

            return data[key].postId;
          });
      }

      function translateStory(data) {

        var order = _getOrderArray(data.jsonData.sources);

        return data.posts
          .filter(function (item) {
            return item.translations && item.translations.length;
          })
          .map(function (item) {

            item.order = order.indexOf(item.id);
            transObject.isPublished(item);
            transObject.translate(item);
            transObject.setBookmark(item);
            transObject.getDuration(item);
            transObject.trueSlug(item);

            return item;
          })
          .sort(function (a, b) {

            return a.order > b.order;
          });
      }
    }
  };
}

export default PostGroupDirective;



// WEBPACK FOOTER //
// ./app/components/nn-modules/nn-post-group/nn-post-group.directive.js